// removed by extract-text-webpack-plugin
module.exports = {"root":"js-components-Spinner-module__root--3k9sb","spinner-rotate":"js-components-Spinner-module__spinner-rotate--x1YZP"};